module.exports = __webpack_public_path__ + "img/salad.41795a56.svg";